// extracted by mini-css-extract-plugin
export var activitySelect = "styles-module__activitySelect___ssB6o";
export var dateSelect = "styles-module__dateSelect___v6DHA";
export var form = "styles-module__form___syWMq";
export var formDateActivity = "styles-module__formDateActivity___wV7bi";
export var formField = "styles-module__formField___ZBtl0";
export var formToggle = "styles-module__formToggle___rrGkc";
export var privacyTrigger = "styles-module__privacyTrigger___jwvWC";